import { app } from "@microsoft/teams-js";
import { SurveyDTO } from "@teams/types/api";
import { useCallback, useState } from "react";

import { FetchError, FetchResult, isSuccess } from "../../_shared/services/ChannelApi";
import { ChannelSurveysOptions, surveyApi } from "../../_shared/services/SurveyApi";

export type ContentScope = "team" | "personal" | "tenant" | "meetings";

export const useChannelSurveys = () => {
  const [isSurveysLoading, setIsSurveysLoading] = useState<boolean>(true);
  const [surveys, setSurveys] = useState<SurveyDTO[]>([]);
  const [surveyError, setSurveyError] = useState<FetchError>();

  const loadSurveys = useCallback(
    async (context: app.Context, scope: ContentScope, options: ChannelSurveysOptions) => {
      setIsSurveysLoading(true);
      setSurveyError(undefined);

      let surveysResponse: FetchResult<SurveyDTO[]> = [];
      switch (scope) {
        case "team":
          surveysResponse = await surveyApi.audienceSurveys(context, options);
          break;
        case "personal":
          surveysResponse = await surveyApi.userSurveysByAudience(context, options);
          break;
        case "tenant":
          surveysResponse = await surveyApi.userSurveys(context, options);
          break;
        case "meetings":
          surveysResponse = await surveyApi.userSurveys(context, {
            ...options,
            filterMeetings: true,
          });
          break;
      }

      if (isSuccess(surveysResponse)) {
        setSurveys(
          surveysResponse.sort((a, b) => getSurveyTime(b).getTime() - getSurveyTime(a).getTime())
        );
      } else {
        setSurveyError(surveysResponse as FetchError);
      }

      setIsSurveysLoading(false);

      return surveysResponse;
    },
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return { surveyError, loadSurveys, isSurveysLoading, surveys, setSurveys };
};

function getSurveyTime(survey: SurveyDTO): Date {
  return survey.deliverAt || survey.updatedAt;
}
